import React, { useState } from "react";
import { Menu, X, LogIn } from "lucide-react";
import { NAV, BRAND } from "./landingData";

export function LandingHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-md border-b border-slate-200" data-testid="landing-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center" data-testid="landing-logo"><img src="/icons/nouvelle-fidelity.png" alt="Nouvelle Fidelity" className="h-10 w-auto" /></a>
        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-slate-600" data-testid="landing-nav">
          {NAV.map((n) => <a key={n.href} href={n.href} className="hover:text-slate-900 transition-colors" data-testid={n.id}>{n.label}</a>)}
        </nav>
        <div className="flex items-center gap-2">
          <a href="#login" className="inline-flex items-center gap-2 rounded-full px-5 h-10 text-sm font-semibold text-white shadow-sm hover:shadow-md transition-[box-shadow,transform] hover:-translate-y-0.5" style={{ background: BRAND }} data-testid="header-login-button"><LogIn className="h-4 w-4" /> Accedi</a>
          <button type="button" onClick={() => setOpen(!open)} className="md:hidden h-10 w-10 rounded-full ring-1 ring-slate-200 flex items-center justify-center text-slate-700" aria-label="Menu" data-testid="landing-menu-toggle">{open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}</button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden border-t border-slate-200 bg-white px-4 py-3 flex flex-col gap-1 animate-fade-up" data-testid="landing-mobile-nav">
          {NAV.map((n) => <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="py-2.5 px-2 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50" data-testid={`mobile-${n.id}`}>{n.label}</a>)}
        </nav>
      )}
    </header>
  );
}
